import {
    SCREENS,
    STATUS_ACTIVE,
    STATUS_CANCELLED,
    STATUS_EXPIRED,
    STATUS_INACTIVE,
    STATUS_PAUSED,
    OFFER_TYPES,
    STATUS_PENDING
} from "../constants/Constants";
import { isBeforeToday } from "./dateUtil";

const STATUS_ENUM: Record<string, number> = {
    [STATUS_ACTIVE]: 3,
    [STATUS_PAUSED]: 2,
    [STATUS_INACTIVE]: 2,
    [STATUS_CANCELLED]: 1,
    [STATUS_EXPIRED]: 1
};

// Is only used by functionalTests for bconnect status check
export function getSubscriptionStatus(
    active: undefined | boolean,
    endDate: undefined | null | string | Date,
    accountStatus: string,
    status?: string
): string {
    if (status === "PENDING") {
        return STATUS_PENDING;
    }

    if (accountStatus === "CANCELLED") {
        return STATUS_CANCELLED;
    }

    if (accountStatus === "EXPIRED" || (endDate && isBeforeToday(endDate))) {
        return STATUS_EXPIRED;
    }

    return active ? STATUS_ACTIVE : STATUS_INACTIVE;
}

export function orderSubscriptionsByStatusAndEndDate(
    a: Subscription,
    b: Subscription
): number {
    if (a.provider !== "ZUORA") {
        return 1;
    }

    if (b.provider !== "ZUORA") {
        return -1;
    }

    const aStatus = STATUS_ENUM[a.status || STATUS_INACTIVE];
    const bStatus = STATUS_ENUM[b.status || STATUS_INACTIVE];

    if (aStatus !== bStatus) {
        return bStatus - aStatus;
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (new Date(b.endDate!)).getTime() - (new Date(a.endDate!)).getTime();
}

export function orderSubscriptionsByStatusAndOfferType(a: Subscription, b: Subscription): number {
    if (!a.ratePlan || a.ratePlan.offerType !== OFFER_TYPES.SINGLE) {
        return 1;
    }

    if (!b.ratePlan || b.ratePlan.offerType !== OFFER_TYPES.SINGLE) {
        return -1;
    }

    const aStatus = STATUS_ENUM[a.status || STATUS_INACTIVE];
    const bStatus = STATUS_ENUM[b.status || STATUS_INACTIVE];

    return bStatus - aStatus;
}

/*
 * It is a realistic scenario for a user to have multiple subscriptions (e.g. an active SINGLE, a cancelled SINGLE, and an
 * active GROUP). Thus, make sure SINGLE, active subscriptions are prioritized over non-SINGLE and non-active subscriptions
 * respectively.
 */
export function findCurrentSubscriptionWithDetails(subscriptions: Subscription[]): null | Subscription {
    return subscriptions.filter(({ ratePlan }) => ratePlan).sort(orderSubscriptionsByStatusAndOfferType)[0];
}

export function hasSubsRedirectTo({ redirectTo }: Record<string, string> & Record<string, unknown> = {}): boolean {
    return new RegExp(SCREENS.SUBSCRIPTION_PURCHASE_FORM).test(redirectTo);
}
